import React, { FC } from 'react'
import { BtText, BtTextProps } from './BtText'

export interface BtInputLabelProps
  extends Omit<BtTextProps, 'size' | 'weight' | 'color'> {
  required?: boolean
}

export const BtInputLabel: FC<BtInputLabelProps> = ({
  children,
  required,
  ...btTextProps
}) => (
  <BtText
    {...btTextProps}
    size={12}
    weight="500"
    color="#003353"
    style={{ marginBottom: 5 }}
  >
    {children}
    {required && '*'}
  </BtText>
)
